module.exports = __webpack_public_path__ + "img/cost_icon_20.3b2cf759.svg";